import { BaseContainerModel } from "../base-container.model";
import {
  bl_mkp_seller_order_event_Rowinterface,
  bl_mkp_seller_order_event_Rowclass,
} from "../../dbschema/index";

export class SellerOrderEventContainerModel extends BaseContainerModel {
  bl_mkp_seller_order_event: bl_mkp_seller_order_event_Rowinterface =
    new bl_mkp_seller_order_event_Rowclass();
} 
